import React, { useState } from "react";
import Accordion from 'react-bootstrap/Accordion';

const Faqs = () => {
    return (
        <div>
            <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                    <Accordion.Header>Preciso de pagar para utilizar a plataforma Nightspot?</Accordion.Header>
                    <Accordion.Body>
                        <strong>NÃO!</strong> Disponibilizamos um plano de utilização grátis. Assim que necessites de outros componentes podes fazer upgrade ao teu plano em qualquer altura.
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                    <Accordion.Header>Qual o primeiro passo?</Accordion.Header>
                    <Accordion.Body>
                        Cria o teu spot e começa já a usufruir da nossa plataforma. É rápido e intuitivo!
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                    <Accordion.Header>Existe limite de eventos?</Accordion.Header>
                    <Accordion.Body>
                        Não, podes criar eventos ilimitados em qualquer um dos planos.
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                    <Accordion.Header>Como funciona a gestão de promotores?</Accordion.Header>
                    <Accordion.Body>
                        Podes adicionar promotores aos teus eventos e acompanhar o desempenho de cada um em tempo real através da área de "Promotores".
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                    <Accordion.Header>Posso vender bilhetes na plataforma?</Accordion.Header>
                    <Accordion.Body>
                        Sim! Suportamos tanto guestlists gratuitas como venda de bilhetes pagos e reservas de mesas VIP.
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="5">
                    <Accordion.Header>Onde vejo as estatísticas do meu spot?</Accordion.Header>
                    <Accordion.Body>
                        Tens acesso a estatísticas detalhadas no teu dashboard principal e métricas específicas em cada evento criado.
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="6">
                    <Accordion.Header>Posso gerir vários spots com a mesma conta?</Accordion.Header>
                    <Accordion.Body>
                        Sim, a plataforma permite-te gerir múltiplos estabelecimentos de forma centralizada e eficiente.
                    </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="7">
                    <Accordion.Header>Como posso obter suporte?</Accordion.Header>
                    <Accordion.Body>
                        Podes contactar-nos através do e-mail <a href="mailto:info@nightspot.pt">info@nightspot.pt</a>.
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>);
}

export default Faqs;